import React from 'react';
import styles from './storeList.module.scss';
import { useRouter } from 'next/router';
import Image from 'next/legacy/image';
import Link from 'next/link';
import useUserAgent from '../../hooks/useUserAgent';
import { slugify } from '../../helpers/slugify';
import { fixImageUrl } from '../../helpers/common';
import { Store } from '../../helpers/store';
import useTranslation from 'next-translate/useTranslation';

interface StoreListProps {
  stores: Store[];
  city?: string;
}

export default function StoreList({ stores, city }: StoreListProps): JSX.Element {
  const { t } = useTranslation('application');
  return (
    <div className={styles['all-stores']}>
      <div className={styles['stores-content']}>
        <div className={styles['stores-list-container']}>
          <h1 className={styles['stores-title']}>{city ? t('store.locationStore', { city }) : t('stores')}</h1>
          <div className={styles['stores-list']}>
            {stores.length > 0 &&
              stores.map((store: Store) => {
                return (
                  <div className={styles['store-wrapper']} key={store.id}>
                    <StoreCard key={store.name} store={store} />
                  </div>
                );
              })}
          </div>
        </div>
      </div>
    </div>
  );
}

type StoreCardProps = {
  store: Store;
};

function StoreCard({ store }: StoreCardProps) {
  const router = useRouter();
  const { isMobile } = useUserAgent();
  const storeName = slugify(store.name);

  function imgLoader({ src }) {
    return fixImageUrl(src);
  }

  return (
    <Link
      href={{
        pathname: `/${router.locale}/${router.asPath}/${storeName}`,
      }}
      className={styles['store-item']}
    >
      {!isMobile && (
        <div className={styles['store-logo-container']}>
          <Image
            alt={store.name}
            className={styles['store-logo']}
            width={102}
            height={102}
            priority
            src={store.logo}
            loader={imgLoader}
          />
        </div>
      )}
      <div className={styles['store-name']}>{store.name}</div>
    </Link>
  );
}
